/* ==========================================================================
   Limelight — floating WhatsApp button
   Keeps the button clear of the sticky add-to-cart bar on product pages.

   Uses transform rather than adjusting `bottom`: the offset then can't be
   affected by whatever else is competing for that property, and it animates
   on the compositor instead of triggering layout on every scroll frame.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var button = document.querySelector('[data-ll-wafloat]');
    if (!button) return;

    var watched = null;
    var frame = null;
    var lastLift = -1;

    function measure() {
      frame = null;

      // The bar is injected after page load, so re-query rather than cache it.
      var bar = document.querySelector('.limelight-sticky-atc');
      var lift = 0;

      if (bar) {
        var rect = bar.getBoundingClientRect();
        var onScreen = !bar.hasAttribute('hidden') && rect.height > 0 && rect.top < window.innerHeight - 4;
        if (onScreen) lift = Math.round(rect.height) + 10;

        if (watched !== bar && window.MutationObserver) {
          watched = bar;
          new MutationObserver(schedule).observe(bar, {
            attributes: true,
            attributeFilter: ['hidden', 'style', 'class']
          });
        }
      }

      if (lift === lastLift) return;
      lastLift = lift;
      button.style.transform = lift ? 'translateY(-' + lift + 'px)' : '';
    }

    function schedule() {
      if (frame === null) frame = window.requestAnimationFrame(measure);
    }

    // First pass runs synchronously: requestAnimationFrame is throttled in
    // background/hidden tabs, and the button should start in the right place
    // regardless.
    measure();

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule);

    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
